<template>
  <Modal
    v-if="showModal"
    :title="fio"
    :img="trainer.photo"
    :disalbe-image-height-stretch="true"
    :as-page="true"
    @close="close"
  >
    <div>
      <MoleculeModalTrainerRowButtons :trainer="trainer" />
      <MoleculeModalRowText v-if="trainer.description" :item="{ title: 'О специалисте', text: trainer.description }" />
    </div>
  </Modal>
</template>

<script>
import MoleculeModalTrainerRowButtons from '../../../../components/molecules/modals/MoleculeModalTrainerRowButtons'
import MoleculeModalRowText from '../../../../components/molecules/modals/MoleculeModalRowText'
import Modal from '../../../../components/templates/layouts/Modal'

export default {
  name: 'STrainerList',
  components: {
    MoleculeModalTrainerRowButtons,
    MoleculeModalRowText,
    Modal,
  },
  async asyncData(ctx) {
    const id = `fitbase/${ctx.route.params.club}/trainers/${ctx.route.params.trainer}`
    const trainer =
      ctx.store.state.modules.content[id] || (await ctx.store.dispatch('modules/content/getContent', { id }))

    if (!trainer || Object.keys(trainer).length === 0) {
      return ctx.error({ statusCode: 404, message: 'Страница не найдена' })
    }

    const fio = [trainer.name, trainer.surname].filter(Boolean).join(' ')
    // if (ctx.i18n.locale) ...
    const meta = {
      metaTitle: `${fio} в фитнес-клубе премиум-класса — Encore Fitness`,
      metaDescription: `${fio} — опытный тренер в сети фитнес-клубов Encore Fitness. Получите персональное сопровождение от лучших профессионалов и достигните своих спортивных целей!`,
    }
    await ctx.store.dispatch('modules/content/saveCustomPageItem', { id: `${id}_meta`, data: { meta } })
    await ctx.store.dispatch('modules/content/setPage', `${id}_meta`)
    return { trainer }
  },
  data() {
    return {
      trainer: {},
    }
  },
  computed: {
    showModal() {
      return !this.$store.getters['entryLoaderScreen/hasPreloadScreen']
    },
    fio() {
      return [this.trainer.name, this.trainer.surname].filter(Boolean).join(' ')
    },
  },
  destroyed() {
    const isToParentRoute = this.$route.path.startsWith('/team')
    if (isToParentRoute) {
      this.$store.dispatch('pageTransition/toDefault')
    }
  },
  methods: {
    close() {
      const canBack = history.length > 2
      if (canBack) {
        this.$router.back()
      } else {
        this.$router.push(`/team/${this.$route.params.club}`)
      }
    },
  },
  meta: {
    theme: 'dark',
  },
}
</script>
